export default "__VITE_ASSET__ChNoGGWi__"